import { useMemberGetQuery, useMemberMutate } from "modules/members/api";
import { stripNils } from "modules/utils";
import { MFApp } from "./apps";

export type MFCatalogApp = {
  app: MFApp;
  hasAccount: boolean;
  hasAccessRequest: boolean;
};

export type MFCatalogConfig = {
  orgId: string;
  enabled: boolean;
  requestAccess: boolean;
  slug: boolean;
  logoUrl?: string;
  ployFields?: string[];
};

type ListFilters = {
  categories?: string[];
};

const useListCatalogApps = (filters: ListFilters): MFCatalogApp[] => {
  const searchParams = new URLSearchParams(
    stripNils({
      categories: filters.categories?.length
        ? filters.categories.join(",")
        : undefined,
    }) as any,
  ).toString();
  const data = useMemberGetQuery<MFCatalogApp[]>(
    ["members", "catalog", "apps", filters],
    "/members/catalog/apps?" + searchParams,
    {
      onError: () => null,
    },
  );
  return data.data || [];
};

const useGetCatalogConfig = (): MFCatalogConfig | undefined => {
  const data = useMemberGetQuery<MFCatalogConfig>(
    ["members", "catalog", "config"],
    "/members/catalog",
    {
      onError: () => null,
    },
  );
  return data.data;
};

export type MFRequestAccessParams = {
  appId: string;
  reason: string;
  accessLevel: string;
};

const useCreateAccessRequest = () => {
  const { mutate, isLoading } = useMemberMutate(
    "POST",
    "/members/catalog/request",
    [["members", "catalog"]],
  );
  return {
    isLoading,
    mutate: (body: MFRequestAccessParams) =>
      mutate({
        app_id: body.appId,
        reason: body.reason,
        access_level: body.accessLevel,
      }),
  };
};

export const MF_CATALOGS = {
  useListCatalogApps,
  useGetCatalogConfig,
  useCreateAccessRequest,
};
